
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"20","cy":"20","r":"15","stroke":"#7D63D6","stroke-width":"6"}}),_c('circle',{attrs:{"cx":"20","cy":"20","r":"7","stroke":"#7D63D6","stroke-width":"4"}}),_c('path',{attrs:{"d":"M9 9l6 6m10 10l6 6M9 31l6-6m10-10l6-6","stroke":"#7D63D6","stroke-width":"6"}})])
          )
        }
      }
    